(() => {
  const money = (cents, format) => {
    const amount = (Number(cents || 0) / 100).toFixed(2);
    if (!format) return `$${amount}`;
    return format
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(Number(amount))))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, String(Math.round(Number(amount))));
  };

  const pad = (n) => String(Math.max(0, n)).padStart(2, '0');

  const init = (root) => {
    if (!root || root.dataset.lumeaReady === 'true') return;
    root.dataset.lumeaReady = 'true';

    const variantsEl = root.querySelector('[data-lumea-variants]');
    const configEl = root.querySelector('[data-lumea-config]');
    let variants = [];
    let config = {};
    try { variants = JSON.parse(variantsEl?.textContent || '[]'); } catch (e) {}
    try { config = JSON.parse(configEl?.textContent || '{}'); } catch (e) {}

    let selectedOffer = root.querySelector('[data-lumea-offer].is-selected');
    const atc = root.querySelector('[data-lumea-atc]');
    const buyNow = root.querySelector('[data-lumea-buy-now]');
    const atcText = root.querySelector('[data-lumea-atc-text]');
    const buyNowText = root.querySelector('[data-lumea-buy-now-text]');
    const errorBox = root.querySelector('[data-lumea-action-error]');

    const setMedia = (mediaId) => {
      if (!mediaId) return;
      root.querySelectorAll('[data-lumea-media-id]').forEach((slide) => {
        const active = String(slide.dataset.lumeaMediaId) === String(mediaId);
        slide.hidden = !active;
        slide.classList.toggle('is-active', active);
      });
      root.querySelectorAll('[data-lumea-thumb]').forEach((thumb) => {
        thumb.classList.toggle('is-active', String(thumb.dataset.mediaId) === String(mediaId));
      });
    };

    root.querySelectorAll('[data-lumea-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => setMedia(thumb.dataset.mediaId));
    });

    const resolveItemVariant = (item) => {
      const selects = [...item.querySelectorAll('[data-lumea-bundle-option]')];
      if (!selects.length) {
        const fallbackId = String(item.dataset.defaultVariantId || '');
        return variants.find((v) => String(v.id) === fallbackId) || variants[0] || null;
      }
      const values = selects
        .sort((a, b) => Number(a.dataset.optionIndex) - Number(b.dataset.optionIndex))
        .map((select) => select.value);
      return variants.find((v) => v.options.every((opt, i) => String(opt) === String(values[i]))) || null;
    };

    const validateItem = (item) => {
      const status = item.querySelector('[data-lumea-bundle-status]');
      const variant = resolveItemVariant(item);
      const valid = Boolean(variant?.available);
      item.classList.toggle('has-error', !valid);
      if (status) status.textContent = valid ? '' : (config.unavailable_text || 'Unavailable selection');
      return valid ? variant : null;
    };

    const validateOffer = (offer) => {
      const rows = [...offer.querySelectorAll('[data-lumea-bundle-item]')];
      const resolved = rows.map(validateItem);
      return resolved.every(Boolean) ? resolved : null;
    };

    const selectedItems = () => selectedOffer ? validateOffer(selectedOffer) : null;

    const updateOfferCompares = () => {
      const firstRow = selectedOffer?.querySelector('[data-lumea-bundle-item]');
      const variant = firstRow ? resolveItemVariant(firstRow) : variants[0];
      if (!variant) return;
      const buy1 = root.querySelector('[data-lumea-buy1-price]');
      if (buy1) buy1.textContent = money(variant.price, config.money_format);
      const c2 = root.querySelector('[data-lumea-buy2-compare]');
      const c4 = root.querySelector('[data-lumea-buy4-compare]');
      if (c2) c2.textContent = money(variant.price * 2, config.money_format);
      if (c4) c4.textContent = money(variant.price * 4, config.money_format);
      const buy1Card = root.querySelector('[data-lumea-offer][data-quantity="1"]');
      if (buy1Card) buy1Card.dataset.displayPrice = money(variant.price, config.money_format);
    };

    const updateButtons = () => {
      if (!selectedOffer) return;
      updateOfferCompares();
      const displayPrice = selectedOffer.dataset.displayPrice || '';
      const items = validateOffer(selectedOffer);
      const available = Boolean(items);
      if (atc) atc.disabled = !available;
      if (buyNow) buyNow.disabled = !available;
      if (atcText) atcText.textContent = `${config.atc_text || 'ADD TO CART'}${displayPrice ? ` — ${displayPrice}` : ''}`;
      if (buyNowText) buyNowText.textContent = `${config.buy_now_text || 'BUY NOW'}${displayPrice ? ` — ${displayPrice}` : ''}`;
      const first = items?.[0];
      if (first?.featured_media_id) setMedia(first.featured_media_id);
    };

    const selectOffer = (card) => {
      root.querySelectorAll('[data-lumea-offer]').forEach((c) => {
        const selected = c === card;
        c.classList.toggle('is-selected', selected);
        c.querySelector('[data-lumea-offer-select]')?.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      selectedOffer = card;
      if (errorBox) {
        errorBox.hidden = true;
        errorBox.textContent = '';
      }
      updateButtons();
    };

    root.querySelectorAll('[data-lumea-offer]').forEach((card) => {
      card.querySelector('[data-lumea-offer-select]')?.addEventListener('click', () => selectOffer(card));
      card.querySelectorAll('[data-lumea-bundle-option]').forEach((select) => {
        select.addEventListener('change', () => {
          if (card !== selectedOffer) selectOffer(card);
          else updateButtons();
        });
      });
    });

    const groupItems = (resolvedVariants) => {
      const grouped = new Map();
      resolvedVariants.forEach((variant) => {
        const id = Number(variant.id);
        grouped.set(id, (grouped.get(id) || 0) + 1);
      });
      return [...grouped.entries()].map(([id, quantity]) => ({ id, quantity }));
    };

    const setLoading = (loading) => {
      [atc, buyNow].forEach((button) => {
        if (!button) return;
        button.disabled = loading;
        button.classList.toggle('is-loading', loading);
        button.setAttribute('aria-busy', loading ? 'true' : 'false');
      });
    };

    const dispatchCartUpdate = async () => {
      try {
        const cartResponse = await fetch(`${config.cart_url}.js`, { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
        const cart = cartResponse.ok ? await cartResponse.json() : null;
        const evt = new Event('shopify:cart:lines-update', { bubbles: true });
        evt.action = 'add';
        evt.promise = Promise.resolve({ cart: cart ? { totalQuantity: cart.item_count } : undefined, detail: {} });
        document.dispatchEvent(evt);
        return cart;
      } catch (e) {
        return null;
      }
    };

    const addBundle = async (goCheckout) => {
      if (!selectedOffer) return;
      const resolved = selectedItems();
      if (!resolved) {
        if (errorBox) {
          errorBox.hidden = false;
          errorBox.textContent = config.unavailable_text || 'Please choose an available option for every item.';
        }
        return;
      }
      if (errorBox) {
        errorBox.hidden = true;
        errorBox.textContent = '';
      }

      setLoading(true);
      try {
        const response = await fetch(config.cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: groupItems(resolved) }),
        });
        const payload = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(payload?.description || payload?.message || 'Could not add the selected items to cart.');

        if (goCheckout) {
          window.location.href = config.checkout_url || '/checkout';
          return;
        }

        await dispatchCartUpdate();
        if (atcText) {
          const previous = atcText.textContent;
          atcText.textContent = config.added_text || 'ADDED TO CART';
          window.setTimeout(() => { atcText.textContent = previous; }, 1800);
        }
        try {
          await customElements.whenDefined('theme-drawer');
          const drawer = document.getElementById('cart-drawer');
          if (drawer && typeof drawer.open === 'function' && !drawer.hasAttribute('open')) drawer.open();
        } catch (e) {}
      } catch (error) {
        if (errorBox) {
          errorBox.hidden = false;
          errorBox.textContent = error?.message || 'Could not add the selected items to cart.';
        }
      } finally {
        setLoading(false);
        updateButtons();
      }
    };

    atc?.addEventListener('click', () => addBundle(false));
    buyNow?.addEventListener('click', () => addBundle(true));

    const initCountdown = () => {
      const timer = root.querySelector('[data-lumea-countdown]');
      if (!timer) return;
      const hoursEl = timer.querySelector('[data-lumea-hours]');
      const minutesEl = timer.querySelector('[data-lumea-minutes]');
      const secondsEl = timer.querySelector('[data-lumea-seconds]');
      const hours = Math.max(1, Number(config.countdown_hours || 9));
      const resetMs = Math.max(1, Number(config.countdown_reset_minutes || 30)) * 60 * 1000;
      const durationMs = hours * 60 * 60 * 1000;
      const key = `lumea-countdown-${config.product_id || 'product'}`;

      const readTarget = () => {
        const raw = Number(localStorage.getItem(key));
        if (!Number.isFinite(raw) || raw <= Date.now()) {
          const next = Date.now() + durationMs;
          localStorage.setItem(key, String(next));
          return next;
        }
        return raw;
      };

      let target = readTarget();
      const tick = () => {
        let remaining = target - Date.now();
        if (remaining <= resetMs) {
          target = Date.now() + durationMs;
          localStorage.setItem(key, String(target));
          remaining = durationMs;
        }
        const totalSeconds = Math.max(0, Math.floor(remaining / 1000));
        const h = Math.floor(totalSeconds / 3600);
        const m = Math.floor((totalSeconds % 3600) / 60);
        const sec = totalSeconds % 60;
        if (hoursEl) hoursEl.textContent = pad(h);
        if (minutesEl) minutesEl.textContent = pad(m);
        if (secondsEl) secondsEl.textContent = pad(sec);
      };
      tick();
      window.setInterval(tick, 1000);
    };

    initCountdown();
    updateButtons();
  };

  const boot = () => document.querySelectorAll('[data-lumea-pdp]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
